import { render } from "./ErrorFormItemView.vue?vue&type=template&id=a208cab6&scoped=true"
import script from "./ErrorFormItemView.vue?vue&type=script&lang=js"
export * from "./ErrorFormItemView.vue?vue&type=script&lang=js"

import "./ErrorFormItemView.vue?vue&type=style&index=0&id=a208cab6&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a208cab6"]])

export default __exports__